"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = nanThrows;
function nanThrows(x, error) {
    if (Number.isNaN(x instanceof Date ? x.getTime() : x)) {
        throw error instanceof Error ? error : new Error(error);
    }
    return x;
}
//# sourceMappingURL=nanThrows.js.map